<template>
  <div>
    <!-- Modal -->
    <div id="edit-modal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center">
            <h2 class="text-center">Edit Query</h2>
            <button type="button" class="close p-0 m-0" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit="submit" class="product-form">
              <div class="row">
                <div class="col-lg-12">
                  <label for="">
                    <span>Username:</span>
                    <input disabled type="text" v-model="help.username" class="form-control">
                  </label>
                  <label for="">
                    <span>Email:</span>
                    <input disabled type="text" v-model="help.email" class="form-control">
                  </label>
                  <label for="">
                    <span>Message:</span>
                    <textarea rows="6" disabled class="form-control" placeholder="Message" v-model="help.message"></textarea>
                  </label>
                  <label for="">
                    <span>Incomming Date:</span>
                    <input disabled type="text" v-model="help.created_at" class="form-control">
                  </label>
                  <label for="">
                    <span>Closed Date:</span>
                    <input disabled type="text" v-model="help.closed_date" class="form-control">
                  </label>
                </div>
              </div>
              <label for="" class="checkbox-icon">
                <span class="text-left">Status:</span>
                <label class="checkbox-container">
                  <input v-model="help.is_closed" type="checkbox">
                  <span class="checkmark"></span>
                </label>
              </label>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">Update</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Help from '@/models/help'
export default{
  name: 'HelpModel',
  props: ['help'],
  data () {
    return {}
  },
  coumputed: {
    help () {
      return new Help(this.help)
    }
  },
  methods: {
    submit (event) {
      event.preventDefault()
      const help = this.help
      this.$store.dispatch('editHelp', help)
        .then(() => {
          this.$toast.success('Query updated successfully')
          // eslint-disable-next-line no-undef
          $('#edit-modal .close').click()
          this.$parent.fetchAllHelps()
        })
        .catch((err) => this.$toast.error(err.response.data.message))
    }
  }
}
</script>

<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 600px;
    margin: 1.75rem auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EditHelpModal.vue